const ImgSRCs = [
  require(`@/assets/images/category1/milestone-last-active.png`),
  require(`@/assets/images/category2/milestone-last-active.png`),
  require(`@/assets/images/category3/milestone-last-active.png`),
  require(`@/assets/images/category4/milestone-last-active.png`),
  require(`@/assets/images/category5/milestone-last-active.png`),
  require(`@/assets/images/category6/milestone-last-active.png`),
  require(`@/assets/images/category7/milestone-last-active.png`),
  require('@/assets/images/milestone-last.png'),
  require(`@/assets/images/category1/milestone-active.png`),
  require(`@/assets/images/category2/milestone-active.png`),
  require(`@/assets/images/category3/milestone-active.png`),
  require(`@/assets/images/category4/milestone-active.png`),
  require(`@/assets/images/category5/milestone-active.png`),
  require(`@/assets/images/category6/milestone-active.png`),
  require(`@/assets/images/category7/milestone-active.png`),
  require('@/assets/images/milestone.png'),
  require(`@/assets/images/category1/step-active.png`),
  require(`@/assets/images/category2/step-active.png`),
  require(`@/assets/images/category3/step-active.png`),
  require(`@/assets/images/category4/step-active.png`),
  require(`@/assets/images/category5/step-active.png`),
  require(`@/assets/images/category6/step-active.png`),
  require(`@/assets/images/category7/step-active.png`),
  require('@/assets/images/step.png'),
  require('@/assets/images/category1/category-note.png'),
  require('@/assets/images/category2/category-note.png'),
  require('@/assets/images/category3/category-note.png'),
  require('@/assets/images/category4/category-note.png'),
  require('@/assets/images/category5/category-note.png'),
  require('@/assets/images/category6/category-note.png'),
  require('@/assets/images/category7/category-note.png'),
  require('@/assets/images/age-1.png'),
  require('@/assets/images/age-2.png'),
  require('@/assets/images/age-3.png'),
  require('@/assets/images/age-4.png'),
  require('@/assets/images/age-5.png'),
  require('@/assets/images/island.png'),
  require('@/assets/images/category1/island-active.png'),
  require('@/assets/images/category2/island-active.png'),
  require('@/assets/images/category3/island-active.png'),
  require('@/assets/images/category4/island-active.png'),
  require('@/assets/images/category5/island-active.png'),
  require('@/assets/images/category6/island-active.png'),
  require('@/assets/images/category7/island-active.png'),
  require('@/assets/images/icons/focus-icon.png'),
  require('@/assets/images/horizontal-cord.png'),
  require('@/assets/images/vertical-cord.png'),
  require('@/assets/images/cord.png'),
  require('@/assets/images/backgound-grow-tree.png'),
];


export function LoadImage(): void {
  ImgSRCs.map(src => {
    const Img = new Image()
    Img.src = src
  })
}
